import { computed, readonly, ref, shallowRef } from "vue";
import { useI18n } from "vue-i18n";
import { getCountries } from "@/core/api/graphql/common";
import { Logger } from "@/core/utilities";
import type { CountryType } from "@/core/api/graphql/types";

export function useCountries() {
  const { t } = useI18n();
  const ACTIVE_COUNTRIES = ["NLD", "BEL"];

  const loading = ref(false);
  const countries = shallowRef<CountryType[]>([]);

  async function loadCountries() {
    loading.value = true;

    try {
      countries.value = await getCountries();
    } catch (e) {
      Logger.error(`useCountries.${loadCountries.name}`, e);
    } finally {
      loading.value = false;
    }
  }

  const countriesList = computed(() => {
    return countries.value.filter((item) => ACTIVE_COUNTRIES.indexOf(item.id) > -1);
  });

  const countriesListTranslated = computed(() => {
    return countriesList.value.map((item) => {
      return {
        ...item,
        name: t("custom.countries." + item.id),
      };
    });
  });

  return {
    loadCountries,
    loading: readonly(loading),
    countries: computed(() => countries.value),
    countriesList: countriesList,
    countriesListTranslated: countriesListTranslated,
  };
}
